import { useAccountScope } from '../context/AccountScope';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';

function EditUserModal({
  abierto,
  setAbierto,
  usuario
}) {
  const { fetch, refreshAccountScope } = useAccountScope();
  const [isMobile, setIsMobile] = useState(() => isMobileLayout());
  useEffect(() => {
    const check = () => setIsMobile(isMobileLayout());
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const [name, setName] =
    useState('');

  const [email, setEmail] =
    useState('');

  const [role, setRole] =
    useState('');

  const [status, setStatus] =
    useState('');

  const [
    nuevaPassword,
    setNuevaPassword
  ] = useState('');

  useEffect(() => {

    if (usuario) {

      setName(usuario.name || '');
      setEmail(usuario.email || '');
      setRole(usuario.role || '');
      setStatus(usuario.status || '');
      setNuevaPassword('');

    }

  }, [usuario]);

  if (!abierto || !usuario)
    return null;

  async function guardarCambios() {

    try {

      const token =
        localStorage.getItem(
          'token'
        );

     const response =
  await fetch(
    `/api/users/${usuario.id}`,
    {
      method: 'PUT',

            headers: {
              'Content-Type':
                'application/json',

              Authorization:
                `Bearer ${token}`
            },

            body: JSON.stringify({
              name,
              email,
              status
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        alert(
          data.error ||
          'Error actualizando usuario'
        );

        return;

      }

      alert(
        'Usuario actualizado'
      );

      setAbierto(false);

      refreshAccountScope();

    } catch (error) {
      if (error?.name === 'AbortError') return;

      console.error(error);

      alert(
        'Error de conexión'
      );

    }

  }

  async function reiniciarPassword() {

    try {

      if (!nuevaPassword) {
        alert(
          'Ingresa una nueva contraseña temporal'
        );
        return;
      }

      if (nuevaPassword.length < 6) {
        alert(
          'La contraseña debe tener mínimo 6 caracteres'
        );
        return;
      }

      const confirmar =
        window.confirm(
          `¿Confirmas reiniciar la contraseña de ${usuario.name}?`
        );

      if (!confirmar) return;

      const token =
        localStorage.getItem(
          'token'
        );

    const response =
  await fetch(
    `/api/users/${usuario.id}/reset-password`,
    {
      method: 'PUT',
            headers: {
              'Content-Type':
                'application/json',

              Authorization:
                `Bearer ${token}`
            },

            body: JSON.stringify({
              password: nuevaPassword
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        alert(
          data.error ||
          'Error reiniciando contraseña'
        );

        return;

      }

      alert(
        'Contraseña reiniciada correctamente'
      );

      setNuevaPassword('');

    } catch (error) {
      if (error?.name === 'AbortError') return;

      console.error(error);

      alert(
        'Error de conexión'
      );

    }

  }

  return (

    <div
      style={{
        position: 'fixed',
        inset: 0,
        background:
          'rgba(15,23,42,0.45)',
        backdropFilter:
          'blur(4px)',
        zIndex: 99999,

        display: 'flex',
        justifyContent:
          'center',

        alignItems: 'center'
      }}
    >

      <div
        style={{
          width: isMobile ? 'calc(100vw - 24px)' : '600px',
          maxHeight: isMobile ? 'calc(100dvh - 40px)' : 'none',
          overflowY: isMobile ? 'auto' : 'visible',
          boxSizing: 'border-box',
          background: '#fff',
          borderRadius: '24px',
          padding: '32px'
        }}
      >

        <h2>
          Editar Usuario
        </h2>

        <input
          value={name}
          onChange={(e) =>
            setName(
              e.target.value
            )
          }
          style={inputStyle}
        />

        <input
          value={email}
          onChange={(e) =>
            setEmail(
              e.target.value
            )
          }
          style={inputStyle}
        />

        <input
          value={role}
          disabled
          style={{
            ...inputStyle,
            background: '#f1f5f9',
            color: '#64748b',
            cursor: 'not-allowed'
          }}
        />

        <select
          value={status}
          onChange={(e) =>
            setStatus(
              e.target.value
            )
          }
          style={inputStyle}
        >
         <option value="active">
  Activo
</option>

<option value="suspended">
  Suspendido
</option>

<option value="inactive">
  Inactivo
</option>
        </select>

        <div
          style={{
            borderTop:
              '1px solid #e2e8f0',
            marginTop: '20px',
            paddingTop: '20px'
          }}
        >

          <h3
            style={{
              marginTop: 0,
              marginBottom: '12px'
            }}
          >
            Reiniciar contraseña
          </h3>

          <input
            type="password"
            placeholder="Nueva contraseña temporal"
            value={nuevaPassword}
            onChange={(e) =>
              setNuevaPassword(
                e.target.value
              )
            }
            style={inputStyle}
          />

          <button
            onClick={reiniciarPassword}
            style={dangerButtonStyle}
          >
            Reiniciar Contraseña
          </button>

        </div>

        <div
          style={{
            display: 'flex',
            justifyContent:
              'flex-end',
            gap: '10px',
            marginTop: '20px'
          }}
        >

          <button
            onClick={() =>
              setAbierto(false)
            }
          >
            Cancelar
          </button>

          <button
            onClick={
              guardarCambios
            }
          >
            Guardar
          </button>

        </div>

      </div>

    </div>

  );

}

const inputStyle = {
  width: '100%',
  padding: '12px',
  marginBottom: '12px',
  border:
    '1px solid #cbd5e1',
  borderRadius: '10px'
};

const dangerButtonStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '10px',
  border: 'none',
  background: '#dc2626',
  color: '#fff',
  fontWeight: '700',
  cursor: 'pointer'
};

export default EditUserModal;
